module.exports = __webpack_public_path__ + "static/assets/a08d07ef22be64a9ee5dc33c24847158.svg";